module.exports = __webpack_public_path__ + "img/fitnessbg2.05545274.png";